import './app.css'

import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'

import Datenschutz from './pages/datenschutz'
import Home from './pages/Home'
import Impressum from './pages/impressum'
import Kontakt from './pages/kontakt'

/**
 * A client side route change leaves the scroll position where it was, so
 * following the footer's "Kontakt" link from the bottom of the home page used
 * to land on a contact page already scrolled past its own heading.
 */
function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' })
  }, [pathname])

  return null
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/kontakt" element={<Kontakt />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/impressum" element={<Impressum />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
)

document.addEventListener('DOMContentLoaded', () => {
  const floatingArrow = document.querySelector('.floating-arrow')
  const scrollArrow = document.getElementById('scroll-arrow')

  if (!floatingArrow) return

  // Scroll handling for fade effect
  const handleScroll = () => {
    const scrollPosition = window.scrollY

    // Fade out when scrolled down more than 100px, fade in when near top
    if (scrollPosition > 100) {
      floatingArrow.classList.add('fade-out')
    } else {
      floatingArrow.classList.remove('fade-out')
    }
  }

  // Initial check
  handleScroll()

  // Add scroll listener
  window.addEventListener('scroll', handleScroll, { passive: true })

  // Smooth scroll to next section
  if (scrollArrow) {
    scrollArrow.addEventListener('click', () => {
      const nextSection = document.querySelector('section:nth-of-type(2)')
      if (nextSection) {
        nextSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
    })
  }
})
